export const SET_SESSION = 'SET_SESSION';
export const CLEAR_SESSION = 'CLEAR_SESSION';

// payload should now contain { sessionId, expiresAt }
export const setSession = ({ expirationTime, state }) => ({
  type: SET_SESSION,
  payload: { expirationTime, state },
});

export const clearSession = () => ({ type: CLEAR_SESSION });
